import { render } from "./Watermark.vue?vue&type=template&id=6b3f0e0b&scoped=true"
import script from "./Watermark.vue?vue&type=script&lang=js"
export * from "./Watermark.vue?vue&type=script&lang=js"

import "./Watermark.vue?vue&type=style&index=0&id=6b3f0e0b&lang=less&scoped=true"

import exportComponent from "E:\\lcz\\WX.Unify\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3f0e0b"]])

export default __exports__